<header class="site-header p-3" [class.scrolled]="scrolled">
  <nav class="header-nav">
    <!-- Logo -->
    <a class="header-logo" routerLink="/" (click)="closeMobileMenu()">
      <div class="logo-icon">
        <img src="assets/logo/brainy-logo.png" alt="Logo" width="100" height="100">
      </div>
      <span class="logo-text ms-2">Brainy International Institute of India</span>
    </a>

    <!-- Desktop Nav -->
    <ul class="nav-links">
      <li><a (click)="scrollTo('hero')" routerLink="/" class="nav-link">Home</a></li>
      <li><a (click)="scrollTo('about')" class="nav-link">About Us</a></li>

      <!-- Students -->
      <li class="has-dropdown">
        <a class="nav-link">Students Programme <i class="bi bi-chevron-down"></i></a>
        <ul class="dropdown-menu">
          <li><a routerLink="/course/advanced-abacus" class="dropdown-item">Advanced Abacus</a></li>
          <li><a routerLink="/course/handwriting-improvement" class="dropdown-item">Handwriting Improvement</a></li>
          <li><a routerLink="/course/spoken-english" class="dropdown-item">Spoken English</a></li>
          <li><a routerLink="/course/vedic-maths" class="dropdown-item">Vedic Maths</a></li>
        </ul>
      </li> 
      <!-- Educators -->
      <li class="has-dropdown">
        <a class="nav-link">Educators Programme <i class="bi bi-chevron-down"></i></a>
        <ul class="dropdown-menu">
          <li><a routerLink="/course/montessori-teacher-training" class="dropdown-item">Teacher Training</a></li>
          <li><a routerLink="/course/diploma-montessori-primary" class="dropdown-item">Montessori Primary</a></li>
          <li><a routerLink="/course/diploma-montessori-elementary" class="dropdown-item">Montessori Elementary</a></li>
        </ul>
      </li>

      <!-- Gallery -->
      @if (hasGalleryData$ | async) {
        <li><a routerLink="/gallery" class="nav-link">Gallery</a></li> 
      }

      <li><a routerLink="/feedback" class="nav-link">Feedback</a></li>
      <li><a routerLink="/franchise" class="nav-link">Franchise</a></li>
      <li><a (click)="scrollTo('contact')" class="nav-link">Contact Us</a></li>
      <li><a href="https://www.instagram.com/brainy_international/" target="_blank"><img src="assets/img/instagram.png" alt="Instagram" width="40" height="40"></a></li>
      <li><a (click)="toggleIsoCert()" style="cursor:pointer;"><img src="assets/img/ISO.png" alt="ISO Certificate" width="40" height="40"></a></li>

    </ul>




    <!-- CTA Button -->
    <!-- <a (click)="scrollTo('hero')" class="header-cta">
      <i class="bi bi-box-arrow-in-right"></i>
      Enquire Now
    </a> -->

    <!-- Mobile Toggle -->
    <button class="mobile-toggle" (click)="toggleMobileMenu()" [attr.aria-expanded]="mobileMenuOpen">
      <i [class]="mobileMenuOpen ? 'bi bi-x-lg' : 'bi bi-list'"></i>
    </button>
  </nav>

  <!-- Mobile Menu -->
  <div class="mobile-menu" [class.open]="mobileMenuOpen">
    <ul class="mobile-nav-links">
      <a routerLink="/" fragment="hero" class="nav-link">Home</a>
<a routerLink="/" fragment="about" class="nav-link">About Us</a>

      <!-- Mobile Students Programme -->
      <li class="mobile-has-dropdown">
        <div class="mobile-nav-label">Students Programme</div>
        <ul class="mobile-dropdown">
          <li><a routerLink="/course/advanced-abacus" (click)="closeMobileMenu()">Advanced Abacus</a></li>
          <li><a routerLink="/course/handwriting-improvement" (click)="closeMobileMenu()">Handwriting Improvement</a></li>
          <li><a routerLink="/course/spoken-english" (click)="closeMobileMenu()">Spoken English</a></li>
          <li><a routerLink="/course/vedic-maths" (click)="closeMobileMenu()">Vedic Maths</a></li>
        </ul>
      </li>

      <!-- Mobile Educators Programme -->
      <li class="mobile-has-dropdown">
        <div class="mobile-nav-label">Educators Programme</div>
        <ul class="mobile-dropdown">
          <li><a routerLink="/course/montessori-teacher-training" (click)="closeMobileMenu()">Teacher Training</a></li>
          <li><a routerLink="/course/diploma-montessori-primary" (click)="closeMobileMenu()">Montessori Primary</a></li>
          <li><a routerLink="/course/diploma-montessori-elementary" (click)="closeMobileMenu()">Montessori Elementary</a></li>
        </ul>
      </li>

      <!-- Mobile Gallery -->
      @if (hasGalleryData$ | async) {
        <li><a routerLink="/gallery" (click)="closeMobileMenu()">Gallery</a></li>
      }

      <li><a routerLink="/feedback" (click)="closeMobileMenu()">Feedback</a></li>
      <li><a routerLink="/franchise" (click)="closeMobileMenu()">Franchise</a></li>
      <a routerLink="/" fragment="contact" class="nav-link">Contact Us</a>
    </ul>
  </div>
</header>

<!-- ISO Certificate Popup -->
@if (showIsoCert) {
  <div class="iso-overlay" (click)="toggleIsoCert()">
    <div class="iso-popup" (click)="$event.stopPropagation()">
      <button class="iso-close-btn" (click)="toggleIsoCert()">
        <i class="bi bi-x-lg"></i>
      </button>
      <img src="assets/img/iso-cert..jpg" alt="ISO Certificate" class="iso-cert-img">
    </div>
  </div>
}